function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Tuy_Web_Icon");

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  points: "53.95 54.86 61.44 62.16 32.06 62.16 32.06 66.72 61.31 66.72 53.94 74.03 57.15 77.27 70.19 64.33 57.13 51.59 53.95 54.86"
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  points: "28.81 38.42 41.85 51.36 45.06 48.12 37.69 40.81 66.94 40.81 66.94 36.25 37.56 36.25 45.05 28.95 41.87 25.69 28.81 38.42"
});

var SvgReverse = function SvgReverse(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReverse, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reverse.95fad696.svg";
export { ForwardRef as ReactComponent };